// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"af860d87","224":"af860d87","394":"af860d87","482":"e43f2841","672":"af860d87","786":"e43f2841","819":"7fb679cb","903":"8ff9b057","910":"7abbab8c"}[chunkId] + ".chunk.css";
};